












import { defineComponent, PropType } from "@vue/composition-api";
import { Participant } from "@scrile/api-provider/dist/api/ParticipantProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";

export default defineComponent({
  name: "ConsentDataDescription",
  props: {
    owner: { type: Object as PropType<UserPublicData>, default: null },
    participant: { type: Object as PropType<Participant>, required: true },
  },
  setup() {
    return {
      getProfileUrl,
    };
  },
});
